/**
 * @Create idler.zhu(zqc.sunny@aliyun.com)
 * @CreateDate  2017/12/11
 */
import {combineReducers} from 'redux';
import {
  SELECT_OPTION,
  RECEIVE_PRODUCT_OPTIONS,
  RECEIVE_EVALUATE,
  UPDATE_EXPRESS_TYPE,
  ACCEPT_PROTOCOL,
  UPDATE_FORM_INPUT,
  UPDATE_ADDRESS,
  RECEIVE_ORDER_INFO,
  UPDATE_BUTTON_STATUS
} from '../actions/step'

const initState = {
  options: {},
  selected: {},
  orderInfo: {},
  expressInfo: {
    pickupType: null,
    name: null,
    phone: null,
    detail: null,
    accept: false,
    unLock: false
  }
};

export const options = (state = initState.options, action) => {
  switch (action.type) {
    case RECEIVE_PRODUCT_OPTIONS:
      return action.data;
    case RECEIVE_EVALUATE:
      return Object.assign(
        {},
        state,
        action.evaluatedOptions,
        { selectedList: action.selectedStrings }
      );
    case RECEIVE_ORDER_INFO:
      return {};
    case UPDATE_BUTTON_STATUS:
      state.isButtonForbid = action.isButtonForbid;
      return {...state};
    default:
      return state;
  }
};

export const selected = (state = initState.selected, action) => {
  switch (action.type) {
    case RECEIVE_ORDER_INFO:
      return {};
    case RECEIVE_PRODUCT_OPTIONS:
      /**
       * 加载商品时重置数据选项
       * props 回购网props回传属性集合
       * desc 普通属性选择集合
       * multi 单多混选集合
       * childDescValues 记录映射子级的id
       * childDescKeys 记录父级的id
       * descTotal 选项条数（包含属性及描述，不包含单多混选）
       * unLock 解锁按钮
       */
      const { propList, descList: { oneList, thrList } = {} } = action.data;
      const childDescValues = Object.keys(action.data.childDescMap || {});
      const pureChildDescMap = {};
      const descTotal = (propList || []).length + (oneList || []).length + (thrList || []).length - childDescValues.length;
      //Map:  thrListItemValue: childDescKey
      childDescValues.forEach(key => pureChildDescMap[action.data.childDescMap[key].pid] = key);
      return {
        props: {},
        desc: {},
        multi: {},
        propsNames: {},
        descNames: {},
        multiNames: {},
        pureChildDescMap,
        childDescValues,
        descTotal,
        unLock: false
      };
    case SELECT_OPTION:
      const _stateNameKey = `${action.types}Names`;
      const _state = {...state[action.types]};
      const _stateName = {...state[_stateNameKey]};
      if (_state[action.id] && _state[action.id] === action.value) {
        _state[action.id] = null;
        delete _stateName[action.id];
      } else {
        _state[action.id] = action.value;
        _stateName[action.id] = action.name;
      }
      state[_stateNameKey] = _stateName;
      state[action.types] = _state;
      // 如果有childDescMap 属性被选中
      // 但 thrList 中触发显示childDescMap显示的属性并未选择该属性
      // 则删除childDescMap 中的属性的选中值
      if (action.types === 'desc' && state.childDescValues.filter(key => key in state.desc).length) {
        descFor:
        for (let key in state.pureChildDescMap) {
          for (let stateKey in state.desc) {
            if (stateKey === key
              && state.desc[key] !== state.pureChildDescMap[key]
              && state.desc[state.pureChildDescMap[key]]) {
              delete state.desc[state.pureChildDescMap[key]];
              continue descFor;
            }
          }
        }
      }
      // 不是单多混选内容的话判断按钮是否可开启
      if (action.types !== 'multi') {
        const propsKeys = Object.keys(state.props).filter(key => state.props[key]);
        const descValues = Object.values(state.desc).filter(val => val);
        // 没有child Desc
        if (!state.childDescValues.length) {
          state.unLock = (propsKeys.length + descValues.length) === state.descTotal;
        } else {
          const includeSelected = state.childDescValues.filter(key => descValues.includes(key));
          state.unLock = (propsKeys.length + descValues.length) === (state.descTotal + includeSelected.length);
        }
      }
      return {...state};
    default:
      return state;
  }
};

export const expressInfo = (state = initState.expressInfo, action) => {
  switch (action.type) {
    case RECEIVE_PRODUCT_OPTIONS:
      return {
        pickupType: null,
        name: null,
        phone: null,
        detail: null,
        accept: false,
        unLock: false
      };
    case RECEIVE_ORDER_INFO:
      return {};
    case UPDATE_EXPRESS_TYPE:
      if (state.pickupType === action.pickupType) {
        state.pickupType = null;
        state.unLock = false;
      } else {
        state.pickupType = action.pickupType;
        state.unLock = checkUnlockState(state);
      }
      return {...state};
    case ACCEPT_PROTOCOL:
      state.accept = !state.accept;
      state.unLock = checkUnlockState(state);
      return {...state};
    case UPDATE_FORM_INPUT:
      state[action.name] = action.value;
      state.unLock = checkUnlockState(state);
      return {...state};
    case UPDATE_ADDRESS:
      state = { ...state, ...action.data };
      state.unLock = checkUnlockState(state);
      return state;
    default:
      return state;
  }
};

export const orderInfo = (state = initState.orderInfo, action) => {
  switch (action.type) {
    case RECEIVE_ORDER_INFO:
      return { ...action.payload, ...action.data };
    default:
      return state;
  }
};

const checkList = ['name', 'phone', 'accept', 'provinceId', 'cityId', 'areaId', 'streetId'];
/**
 * 校验按钮状态
 * @param state
 * @return {boolean}
 */
export const checkUnlockState = state => {
  if (state.pickupType === null) {
    return false;
  }
  for (let i = 0; i < checkList.length; i++) {
    if (!state[checkList[i]]) {
      return false;
    }
  }
  if (state.pickupType === 1 && !state.detail) {
    return false;
  }
  return true;
};

/**
 * 过滤可使用的选项列表
 * @param skuList {Array}
 * @param selected {Object}
 * @param index {number}
 * @param ignore {number}
 * @return Array
 */
export const filterSelection = (skuList, selected, index = 0, ignore) => {
  // 结束过滤返回实际可选择数组
  if (index === selected.length) {
    return selected.map((_, i) => {
      const key = {};
      skuList.forEach(item => key[item[i]] = key[item[i]]);
      return Object.keys(key);
    });
  }
  // 当前选项为空时可接受任意值
  if (!selected[index] || index === ignore) {
    // 直接跳过当前过滤目标进入下一级过滤
    return filterSelection(skuList, selected, index + 1, ignore);
  }
  // 实际过滤
  const filterValue = selected[index];
  return filterSelection(
    skuList.filter(item => item[index] === filterValue),
    selected,
    index + 1,
    ignore
  );
};

/**
 * 排序sku列表
 * @param list
 * @param skuList
 * @return Array
 */
export const sortSkuList = (list, skuList) => {
  // 取得有序列表属性值对应下标的map
  const keysMap = {};
  list.forEach((item, i) => {
     item.child.forEach(item => keysMap[item.id] = i);
  });
  return skuList.map(item => {
    const list = [];
    item.forEach(key => list[keysMap[key]] = (key + ''));
    return list;
  })
};

/**
 * 获取列表一的id列表
 * @param list
 * @return Array(string)
 */
export const mapKeysOfOneList = list =>
  list.map(item => item.id);

/**
 * 重新组织单多混选的列表二
 * @param list
 * @return Array
 */
export const filterTwoList = list =>
  [{
    name: '功能问题（多选或不选）',
    isElects: true,
    len: list.reduce((prev, action) => prev + action.child.length, 0),
    child: list
  }];

/**
 * 合并可能有子选项的列表三
 * @param list
 * @param map
 * @return Array
 */
export const combineThrList = (list, map) => {
  if (!map) {
    return list;
  }
  let newList = [];
  Object.values(map).forEach(item => {
    newList = list.reduce((prev, action) => {
      prev.push(action);
      if (action.id === item.pid) {
        prev.push(item);
      }
      return prev;
    }, [])
  });
  return newList;
};


/**
 * 遍历默认属性列表
 * @param list
 * @return {{
 *  [string]: string
 * }}
 */
export const mapDefaultProps = list => {
  const defaultProps = {};
  list.forEach(item => {
    defaultProps[item.id] = item.defaultId;
  });
  return defaultProps;
};

/**
 * 获取选项的值及其对应的描述
 * @param list {Array}
 * @param optionData {Object}
 * @param getDefault {Boolean?}
 * @return {{
 *  string: [string],
 *  values: [string]
 * }}
 */
const getOptionSelected = (list, optionData, getDefault) => {
  const string = [];
  const values = list.map(item => {
    const value = optionData[item.id];
    if (!value && getDefault) {
      return item.defaultId;
    }
    for (let i = 0; i < item.child.length; i++) {
      if (item.child[i].id === value) {
        string.push((item.child[i].name + '').trim());
        break;
      }
    }
    return value;
  }).filter(id => id);
  return { string, values };
};

/**
 * 拼装去估价的数据
 * @param options
 * @param selected
 * @return {{
 *  propertyIds: string,
 *  descIds: string,
 *  productDetail: string,
 *  productId: string,
 *  supplierProductId: string,
 *  productName: string,
 *  supplierId: number,
 *  terminalType: number
 *  }}
 */
export const getToEvaluateData = (options, selected) => {
  const propSelected = options.propList
    ? getOptionSelected(options.propList, selected.props)
    : { string: [], values: [] };
  const oneSelected = getOptionSelected(options.descList.oneList, selected.desc);
  const thrSelected = getOptionSelected(options.descList.thrList, selected.desc);
  const twoSelected = getOptionSelected(options.descList.twoList[0].child, selected.multi, true);
  const selectedStrings = [].concat(
    propSelected.string,
    oneSelected.string,
    thrSelected.string,
    twoSelected.string
  );
  const propertyIds = propSelected.values.join(',') || null;
  const descIds = [].concat(
    oneSelected.values,
    thrSelected.values,
    twoSelected.values
  ).join(',');
  const productDetail = [options.name].concat(selectedStrings).join('|');
  return {
    propertyIds,
    descIds,
    selectedStrings,
    productDetail,
    productId: options.id,
    supplierProductId: options.supplierProductId,
    productName: options.name,
    supplierId: options.supplierId,
    terminalType: 2
  }
};

/**
 * 生成下单数据结构
 * @param state
 * @return {{
 *  supplierId: string,
 *  supplierCacheKey: string,
 *  terminalType: number,
 *  productId: number,
 *  supplierProductId: string,
 *  productName: string,
 *  inquiryPrice: number,
 *  pickupType: number,
 *  phone: string,
 *  contactName: string,
 *  address: string
 * }}
 */
export const getToOrderData = state => {
  const { productId, supplierProductId, productName, inquiryPrice, supplierCacheKey, supplierId } = state.options;
  const { pickupType, phone, name: contactName, detail, province: regionProvince, city: regionCity, area: regionDistrict, street: regionBlock } = state.expressInfo;
  const address = `${regionProvince}${regionCity}${regionDistrict}${regionBlock}${pickupType === 1 ? detail : ''}`;
  return {
    supplierId,
    supplierCacheKey,
    terminalType: 2,
    productId,
    supplierProductId,
    productName,
    inquiryPrice,
    pickupType,
    phone,
    contactName,
    address,
    regionProvince,
    regionCity,
    regionDistrict,
    regionBlock
  }
};

export default combineReducers({
  options,
  selected,
  expressInfo,
  orderInfo
})



// WEBPACK FOOTER //
// ./src/reducers/step.js